var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-title  mt-4 mx-5" }, [
      _vm._v("  Top Terms ")
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "row ontology-small" },
      _vm._l(_vm.ontology.topConcepts, function(concept, key) {
        return _c("li", { key: key, staticClass: "col-3 ontology-list " }, [
          _c(
            "label",
            {
              staticClass: "ontology-small-title ml-1",
              on: {
                click: function($event) {
                  _vm.gotoConcept(concept)
                }
              }
            },
            [_vm._v("\n                " + _vm._s(concept.concept.label))]
          )
        ])
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-772703e7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772703e7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OntologyPane.vue
// module id = null
// module chunks = 